// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage, intlShape } from 'react-intl';
import { CommaFormat } from '../../../../elements/Price/Price';

import style from './ResultBox.scss';
import buttonStyle from '../../../../assets/styles/button.scss';

import type { WishListItem } from '../../../../entities';
import icons from '../../../../assets/styles/icons.scss';

type Props = {
  +product: WishListItem;
  +isOwner: boolean;
  +handleOpenProductModal: (productId: string) => void;
  +handleOpenDeleteModal: (productId: string) => void;
};

export default class ResultBox extends Component<Props> {

  render() {
    const { product, isOwner, handleOpenProductModal, handleOpenDeleteModal } = this.props;
    let link = `/new-order/product?originType=WISHLIST&product=${product.encoded}`;
    return (
      <Fragment>
        <section className={style.orderBox}>
          <img className={style.imageWrap}
               src={product.image} alt="image"/>
          <section className={style.rightWrapper}>
            <section className={style.leftContent}>
              <section className={style.contentWrap}>
                <a href={product.url}
                   target="_blank"
                   rel="nofollow noopener nofollow"
                   className={style.name}>{product.name}</a>

                {!!product.description &&
                <p className={classNames(style.description, style.default)}>{product.description}</p>}
                {!!product.onlineStore && !!product.onlineStore.logo &&
                <section className={style.logoWrap}>
                  {/*<a href={product.url}
                     target="_blank"
                     className={style.url}><i className={icons.symbolLink}/></a>*/}
                  <img src={product.onlineStore.logo} alt={product.onlineStore.name}/>
                </section>}
                {isOwner &&
                <section className={classNames(style.options, style.default)}>
                  <FormattedMessage id="wishList.delete.label">{
                    txt => <a className={style.option}
                              onClick={() => handleOpenDeleteModal(product.number)}>{txt}</a>
                  }</FormattedMessage>
                  <FormattedMessage id="wishList.edit.label">{
                    txt => <a className={style.option}
                              onClick={() => handleOpenProductModal(product.number)}>{txt}</a>
                  }</FormattedMessage>
                </section>}
                {/*<section className={style.discountWrap}>
                    <FormattedMessage id="newOrder.search.resultBox.discount">{
                      txt => <p className={style.discount}>{product.discount}{txt}</p>
                    }</FormattedMessage>
                  </section>*/}
              </section>
            </section>
            {!!product.price &&
            <section className={style.rightContent}>
              {!!product.freeShipping && <FormattedMessage id="wishList.resultBox.freeShipping">{
                txt => <p className={style.bonus}>{txt}</p>
              }</FormattedMessage>}
              {!!product.taxFree && <FormattedMessage id="wishList.resultBox.taxFree">{
                txt => <p className={style.bonus}>{txt}</p>
              }</FormattedMessage>}
              <p className={style.price}>$ <CommaFormat price={product.price}/></p>
              <FormattedMessage id="wishList.resultBox.quote">{
                txt => <a href={link}
                          target="_blank"
                          className={classNames(buttonStyle.btn, buttonStyle.lightBlue,
                            style.quote, style.default)}>{txt}</a>
              }</FormattedMessage>
            </section>}
          </section>
          {!!product.description &&
          <p className={classNames(style.description, style.mobile)}>{product.description}</p>}
          {!!product.price &&
          <FormattedMessage id="wishList.resultBox.quote">{
            txt => <a href={link}
                      target="_blank"
                      className={classNames(buttonStyle.btn, buttonStyle.lightBlue,
                        style.quote, style.mobile)}>{txt}</a>
          }</FormattedMessage>}
          {isOwner &&
          <section className={classNames(style.options, style.mobile)}>
            <FormattedMessage id="wishList.delete.label">{
              txt => <a className={style.option}
                        onClick={() => handleOpenDeleteModal(product.number)}>{txt}</a>
            }</FormattedMessage>
            <FormattedMessage id="wishList.edit.label">{
              txt => <a className={style.option}
                        onClick={() => handleOpenProductModal(product.number)}>{txt}</a>
            }</FormattedMessage>
          </section>}
        </section>
      </Fragment>);
  }
}

ResultBox.propTypes = {
  product: PropTypes.object.isRequired,
  isOwner: PropTypes.bool.isRequired,
  handleOpenProductModal: PropTypes.func.isRequired,
  handleOpenDeleteModal: PropTypes.func.isRequired,
};

ResultBox.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/wish-list/components/ResultBox/ResultBox.jsx